import React from "react";
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";

const EditableInternalNotes = ({ order, setOrder }) => {
  const internal = order.internal || {};

  const handleChange = (field, value) => {
    setOrder({
      ...order,
      internal: { ...order.internal, [field]: value },
    });
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Internal Notes
      </Typography>

      <Stack spacing={2} mt={2}>
        <TextField
          label="Kitchen Notes"
          multiline
          rows={4}
          fullWidth
          value={internal.kitchenNotes || ""}
          onChange={(e) => handleChange("kitchenNotes", e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={internal.isRushOrder || false}
              onChange={(e) => handleChange("isRushOrder", e.target.checked)}
            />
          }
          label="Rush Order"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={internal.isHighPriority || false}
              onChange={(e) => handleChange("isHighPriority", e.target.checked)}
            />
          }
          label="High Priority"
        />
      </Stack>
    </Box>
  );
};

export default EditableInternalNotes;
